import n from "react";
import e from "../../../../node_modules/classnames/index.js";
function t(n) {
  if (void 0 === n) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function i(n, e) {
  for (var t = 0; t < e.length; t++) {
    var i = e[t];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(n, i.key, i);
  }
}
function o(n, e, t) {
  return e in n ? Object.defineProperty(n, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[e] = t, n;
}
function r(n) {
  return (r = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  })(n);
}
function p(n, e) {
  return (p = Object.setPrototypeOf || function (n, e) {
    return n.__proto__ = e, n;
  })(n, e);
}
var s = function (s) {
  !function (n, e) {
    if ("function" != typeof e && null !== e) throw TypeError("Super expression must either be null or a function");
    n.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: n,
        writable: !0,
        configurable: !0
      }
    }), e && p(n, e);
  }(f, s);
  var l,
    a,
    c,
    u = (l = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (n) {
        return !1;
      }
    }(), function () {
      var n,
        e,
        i = r(f);
      if (l) {
        var o = r(this).constructor;
        e = Reflect.construct(i, arguments, o);
      } else e = i.apply(this, arguments);
      return (n = e) && ("object" == (n && "undefined" != typeof Symbol && n.constructor === Symbol ? "symbol" : typeof n) || "function" == typeof n) ? n : t(this);
    });
  function f() {
    var n;
    return !function (n, e) {
      if (!(n instanceof e)) throw TypeError("Cannot call a class as a function");
    }(this, f), n = u.apply(this, arguments), o(t(n), "state", {
      pinned: !1
    }), o(t(n), "positionNow", void 0), o(t(n), "placeholder", void 0), o(t(n), "container", void 0), o(t(n), "resize", function () {
      n.state.pinned && (n.unpin(), n.pin());
    }), o(t(n), "getContainerRect", function () {
      return n.container.getBoundingClientRect();
    }), o(t(n), "pin", function () {
      var e = n.getContainerRect();
      n.setState({
        pinned: !0,
        position: "fixed",
        width: e.width,
        top: n.props.top,
        zIndex: n.props.zIndex || 10
      }), n.placeholder.style.paddingTop = e.height + "px", n.props.onPin && n.props.onPin();
    }), o(t(n), "unpin", function () {
      n.setState({
        pinned: !1,
        position: "",
        width: null,
        top: null,
        zIndex: 1
      }, n.position), n.placeholder.style.paddingTop = "", n.props.onUnpin && n.props.onUnpin();
    }), o(t(n), "shouldPin", function () {
      if (n.props.disablePinning) return !1;
      var e = n.container.parentNode.getBoundingClientRect(),
        t = n.getContainerRect(),
        i = e.top <= n.props.top && e.bottom > n.props.top + t.height;
      return !n.props.disabled && (n.props.permanently || i);
    }), o(t(n), "position", function () {
      if (!1 !== n.props.visible && (!n.props.disabled || n.state.pinned)) {
        var e = n.shouldPin();
        n.state.pinned && !e && n.unpin(), !n.state.pinned && e && n.pin();
      }
    }), n;
  }
  return a = [{
    key: "componentDidMount",
    value: function value() {
      this.positionNow = this.position, this.props.permanently ? this.pin() : this.props.scrollContainer.addEventListener("scroll", this.position), this.props.scrollContainer.addEventListener("resize", this.resize);
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      if (this.props.scrollContainer.removeEventListener("scroll", this.position), this.props.scrollContainer.removeEventListener("resize", this.resize), this.state.pinned) {
        var n;
        (null === (n = this.container) || void 0 === n ? void 0 : n.nextSibling) && (this.container.nextSibling.style.marginTop = "0");
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function value(n) {
      (n.disabled !== this.props.disabled || n.permanently !== this.props.permanently) && this.positionNow(), !n.disablePinning && this.props.disablePinning && this.state.pinned && this.unpin();
    }
  }, {
    key: "render",
    value: function value() {
      var t = this;
      if (!1 === this.props.visible) return null;
      var i = e("react-pin__inner-container", this.props.className, this.state.pinned && "pin"),
        o = this.state;
      o.pinned;
      var r = function (n, e) {
        if (null == n) return {};
        var t,
          i,
          o = function (n, e) {
            if (null == n) return {};
            var t,
              i,
              o = {},
              r = Object.keys(n);
            for (i = 0; i < r.length; i++) t = r[i], e.indexOf(t) >= 0 || (o[t] = n[t]);
            return o;
          }(n, e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(n);
          for (i = 0; i < r.length; i++) t = r[i], !(e.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(n, t) && (o[t] = n[t]);
        }
        return o;
      }(o, ["pinned"]);
      return n.createElement("div", {
        ref: function ref(n) {
          return t.placeholder = n;
        }
      }, n.createElement("div", {
        className: i,
        style: r,
        ref: function ref(n) {
          return t.container = n;
        }
      }, this.props.children));
    }
  }], i(f.prototype, a), c && i(f, c), f;
}(n.Component);
o(s, "defaultProps", {
  scrollContainer: window
});
export { s as Pin };